<template>

    <div class="zp-main">
        <el-image style="margin: auto;height: 170px;width: 1515px;border-radius: 4px;"
                  :src="banner"/>
        <div class="zp-content">

            <el-row>
                <el-col style="margin: 15px;">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/recruit/list' }"><i class="el-icon-menu"></i> 校园招聘
                        </el-breadcrumb-item>
                        <el-breadcrumb-item>职位详情</el-breadcrumb-item>
                    </el-breadcrumb>
                </el-col>
            </el-row>

            <el-descriptions title="职位信息" style="margin: 30px;">
                <el-descriptions-item label="职位名称">
                    <el-tag size="small">{{zpPost.postname}}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="工作地点">{{zpPost.workaddr}}</el-descriptions-item>
                <!--<el-descriptions-item label="工作类型">{{zpPost.workspecial}}</el-descriptions-item>-->
                <el-descriptions-item label="工作经验">{{zpPost.workexperience ? zpPost.workexperience:'无'}}</el-descriptions-item>
                <!--<el-descriptions-item label="学历要求">
                    <el-tag size="small">{{zpPost.educationreq?zpPost.educationreq:'无'}}</el-tag>
                </el-descriptions-item>-->
                <el-descriptions-item label="招聘人数">{{zpPost.demandcount}}</el-descriptions-item>
                <el-descriptions-item label="发布时间">{{zpPost.fbzwdate}}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions direction="vertical" style="margin: 30px; " :column="1"
                             :labelStyle="{'font-size':'16px','color': '#000000','font-weight': 'bold'}">
                <el-descriptions-item label="职位描述">
                    {{zpPost.jobduty?zpPost.jobduty:'无'}}
                </el-descriptions-item>
                <el-descriptions-item label="任职要求">
                    {{zpPost.jobqualify?zpPost.jobqualify:'无'}}
                </el-descriptions-item>
            </el-descriptions>
            <el-row>
                <el-col :span="4" :offset="6">
                    <el-button type="primary" style="width: 200px;" @click="toSubmitResume()">投递此职位</el-button>
                </el-col>
                <el-col :span="4">
                    <el-button type="primary" plain style="width: 200px;" @click="toList()">返回职位列表</el-button>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>

    export default {
        name: "zp_detail",
        data() {
            return {
                id: 0,
                url: '',
                zpPost: {},
                banner: require('@/assets/banner.jpg')
            }
        },
        created() {
            this.id = this.$route.query.id;
            this.url = `/zp-post/get-by-id/${this.id}`
            console.log(this.url, this.id);
            this.getById();
        }
        ,
        methods: {
            getById() {
                this.$HttpService.get(this.url).then(res => {
                    console.log(res);
                    this.zpPost = res;
                }).catch(() => {

                })
            },
            toList() {
                this.$router.push({path: '/recruit/list'});
            },
            toSubmitResume(){
                debugger;
                this.$router.push({path: `/recruit/submit_resume/${this.id}`});
            }
        }
    }
</script>
<style scoped>

    .zp-content {
        margin: auto;
        height: 580px;
        width: 1500px;
        padding: 8px;
        background-color: #FFF;
        border-radius: 4px;
    }

</style>
